import React, { useState, useEffect } from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import { useIntl } from '@atlassian/jira-intl';
import {
	ParentLinkFieldEdit,
	type Option as FieldValue,
} from '@atlassian/jira-issue-field-parent-link';
import { FieldMessage, withFormField, FieldContainer } from '../../common/ui';
import { DisabledEpicLinkParentLinkField } from '../../common/ui/fields/epic-link-parent-link-disabled';
import { closeMenuOnScroll } from '../../common/utils/select';
import messages from './messages';
import type { ParentLinkFieldConfig, Props } from './types';
import { validateParentLinkField } from './utils';

const ParentLinkField = (props: Props) => {
	const {
		fieldId,
		fieldName,
		autoCompleteUrl = '',
		fieldProps: { value = null, onChange },
		width,
		autoFocus = false,
		// @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
		onCloseMenuOnScroll = closeMenuOnScroll,
		isDropdownMenuFixedAndLayered = false,
		selectedProject,
		selectedIssueTypeLabel,
		selectedIssueTypeId,
		isEpicLinkSelected,
		isEditable = true,
		nonEditableReason,
		isMini,
	} = props;

	const { formatMessage } = useIntl();

	const [description, setDescription] = useState<string>('');

	useEffect(() => {
		if (isEpicLinkSelected) {
			setDescription(formatMessage(messages.tooltip));
		} else if (isEditable === false) {
			setDescription(nonEditableReason?.message || '');
		}
	}, [description, isEditable, isEpicLinkSelected, formatMessage, nonEditableReason?.message]);

	const shouldDisableParentLink = (): boolean =>
		isEditable === false || isEpicLinkSelected === true;

	// We are disabling the Epic Link and Parent Link fields for taking input and instead displaying that the user should
	// use the Parent field to set the Parent of the issue as part of migrating to a single way of representing Jira's hierarchy.
	return ff('disable-epic-link-and-parent-link-fields-in-issue-view-and-gic_zixrt') ? (
		<FieldContainer width={width}>
			<DisabledEpicLinkParentLinkField />
		</FieldContainer>
	) : (
		<FieldContainer width={width}>
			<ParentLinkFieldEdit
				fieldId={fieldId}
				value={value}
				onChange={onChange}
				isDisabled={shouldDisableParentLink()}
				autoFocus={autoFocus}
				autoCompleteUrl={autoCompleteUrl}
				onCloseMenuOnScroll={onCloseMenuOnScroll}
				isDropdownMenuFixedAndLayered={isDropdownMenuFixedAndLayered}
				selectedProjectId={selectedProject ? selectedProject.value : ''}
				selectedIssueTypeLabel={selectedIssueTypeLabel}
				selectedIssueTypeId={selectedIssueTypeId}
				fetchSuggestionsOnFocus
			/>
			{shouldDisableParentLink() && (
				<FieldMessage fieldName={fieldName} description={description} isMini={isMini} />
			)}
		</FieldContainer>
	);
};
export default withFormField({
	validator: validateParentLinkField,
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<ParentLinkFieldConfig, Option>, any>'.
})<ParentLinkFieldConfig, FieldValue>(ParentLinkField);
